import { useQueryClient } from '@tanstack/react-query';
import { useEventListener } from 'src/core/hooks/useEventListener';
import { contentListQueries } from 'src/modules/contentList/queries';
export function useInvalidatePagesAfterBulkDripping({ selectedPages, pages, selectAll }) {
    const queryClient = useQueryClient();
    useEventListener('app-club-admin:bulkactionsmenu:close', () => {
        selectAll(false);
        const selectedPageModuleIds = Array.from(new Set(pages.flatMap((page) => (selectedPages[page.id] ? [page.moduleId] : []))));
        selectedPageModuleIds.forEach((selectedPageModuleId) => {
            queryClient.invalidateQueries({
                queryKey: contentListQueries.getPages(selectedPageModuleId).queryKey
            });
        });
    });
}
